<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>

                <!-- Location PARAMS -->
                <div class="panel-tag mt-2">
                    {{__t("UBER_LOCATION_PARAMS")}}
                </div>

                <div class="form-group mt-2" v-for="general_field in general_fields">
                    <label class="form-label" >
                        {{general_field.title}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input :disabled="general_field.key == 'store_id'" :id="general_field.key" type="text" class="form-control" v-model="location.general_fields[general_field.key]">
                    </div>

                    <div class="form-group mt-2">
                        <b-overlay :show="is_load_ext">


                        <label class="form-label" for="ext_rests">
                            {{__t("UBER_REST")}}*
                        </label>

                        <div class="" v-if="ext_restaurants.length > 0">
                            <v-select v-model="general_uber_store_id"
                                      class="imc_reasons"
                                      label="name"
                                      :reduce="rest => rest.store_id"
                                      :options="ext_restaurants"
                                      :filterable="false"
                            >
                                <template slot="no-options">
                                    {{__t("CHOICE_REST")}}
                                </template>

                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <div>
                                            {{ option.name }}
                                        </div>
                                        <div>
                                            <small>
                                                {{option.store_id}}
                                            </small>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        </b-overlay>
                    </div>


                </div>


                <location_general_params :location="location"></location_general_params>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";

export default {
    name: "uber_general_tab",

    components : {
        Location_general_params,
        vSelect
    },

    props : {
        location : {
            type : Object
        }
    },

    mounted() {
        this.load_ext_rests();
    },

    data() {
        return {
            is_load_ext : false,
            ext_restaurants : [],
        }
    },

    methods : {

        async load_ext_rests() {
            this.ext_restaurants = [];
            this.is_load_ext = true;
            agr_api.get('/aggregators/uber/external_restaurants').then(({data}) => {
                this.is_load_ext = false;
                if (data.status === "operation_success") {
                    this.ext_restaurants = data.data;
                }
            }).catch(({response}) => {
                this.is_load_ext = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },
    computed: {

        general_fields() {
            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if(key != 'id') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }

                return res;
            }
            return [];
        },

        general_uber_store_id : {
            get() {
                return this.location.general_fields['store_id'];
            },
            set(val) {
                this.location.general_fields['store_id'] = val;
            }

        },

    }
}
</script>

<style scoped>

</style>
